export default __webpack_public_path__ + "static/media/2_0058.57478dac.webp";